import { render } from "./SubscriptionFeatures.vue?vue&type=template&id=d2716d78"
import script from "./SubscriptionFeatures.vue?vue&type=script&lang=js"
export * from "./SubscriptionFeatures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/marketing/SubscriptionFeatures.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d2716d78"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d2716d78', __exports__)) {
    api.reload('d2716d78', __exports__)
  }
  
  module.hot.accept("./SubscriptionFeatures.vue?vue&type=template&id=d2716d78", () => {
    api.rerender('d2716d78', render)
  })

}


export default __exports__